import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    NumberField,
    ReferenceField,
    Filter,
    BooleanInput,
    ReferenceInput,
    SelectInput,
    TextInput, BooleanField,
    NumberInput,
} from 'react-admin';
import SgxDateField from '../components/sgxDateField';

const ReglaFilter = props =>(
  <Filter {...props} >
      <NumberInput source="id" />
      <TextInput source="descripcion"/>
      <BooleanInput source="deleted" defaultValue={false}/>
      <ReferenceInput source="estado" reference="estado-regla">
          <SelectInput optionText="descripcion" optionValue="id"/>
      </ReferenceInput>
  </Filter>
);

const ReglaList = (props) => (
  <List {...props} bulkActionButtons={false} filters={<ReglaFilter/>} >
    <Datagrid rowClick="show">
       <NumberField source="id" />
       <TextField source="descripcion" />
       <TextField source="descripcionCompleta" />
       <TextField source="idCodigoRechazo" />
       <ReferenceField source="idTipoRegla"
                      reference="tipos-regla" link={false}>
        <TextField  source="descripcion" />
       </ReferenceField>
       <ReferenceField
            source="idGrupoRegla"
            reference="grupo-regla"
        >
        <TextField source="descripcion" />
        </ReferenceField>
        <ReferenceField source="estado"
                      reference="estado-regla" link={false}>
        <TextField  source="descripcion" />
        </ReferenceField>
        <BooleanField label="resources.regla.fields.deleted" source="deleted"/>
        <SgxDateField source="desde" />
        <SgxDateField source="hasta" />
    </Datagrid>
  </List>
);

export default ReglaList;
